import { Validation } from "constants/Validation";
import * as Yup from "yup";

export const loginSchema = Yup.object({
    email: Yup.string().required("Please enter user name").matches(Validation.userName.regex, Validation.userName.message),
    password: Yup.string().required('Please enter your password'),
    // captchaValue: Yup.string().required('Please enter captcha') 
})
